export const svData = `
  <div class="paragraph">
    <div class="page-title">Vanliga frågor om Trade-In-programmet (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Vem kan delta i Trade-In-programmet?</div>
    <div class="text-box">
      <div class="text">
        Trade-In-tjänsten är tillgänglig för personer som är 18 år eller äldre och lagligen bosatta i en medlemsstat i Europeiska unionen eller i Storbritannien.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vad ska jag göra innan jag skickar min gamla enhet?</div>
    <div class="text-box">
      <div class="text">
        Innan du skickar enheten:<br>
        • Radera all personlig data och ta bort eventuella PIN-koder, lösenord eller skärmlås.<br>
        • Utför en fullständig fabriksåterställning.<br>
        • På iPhone: koppla bort ditt iCloud-konto genom att stänga av "Hitta min iPhone".<br>
        • På Android: ta bort ditt Google-konto (Inställningar > Konton > Google > Ta bort konto).<br>
        Detta säkerställer att enheten inte längre är kopplad till ditt konto och skyddar din personliga information.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hur skickar jag min gamla enhet?</div>
    <div class="text-box">
      <div class="text">
        <strong>Förpackning:</strong> använd en stadig, ogenomskinlig kartong (inte genomskinlig) och lägg till inre skydd (t.ex. bubbelplast) för att förhindra skador under transporten.<br>
        <strong>Fraktetikett:</strong> om du inte har lämpligt emballage kan du be om detta på inlämningsstället när du lämnar paketet.<br>
        <strong>Dokumentation:</strong> skriv ut, fyll i och underteckna Ärlighetsförklaringen och lägg den i paketet innan du försluter det.<br>
        <strong>Säker förslutning:</strong> se till att paketet är ordentligt stängt och fäst den kostnadsfria fraktetiketten på en synlig plats.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vilka typer av enheter accepteras inte?</div>
    <div class="text-box">
      <div class="text">
        Vi accepterar inte enheter som:<br>
        • är SIM-låsta till en operatör;<br>
        • inte kan startas eller laddas;<br>
        • inte kan anslutas via Bluetooth eller Wi-Fi;<br>
        • har interna komponent- eller moderkortsproblem;<br>
        • fortfarande är kopplade till iCloud- eller Google-konton;<br>
        • är förfalskningar eller kopior;<br>
        • är allvarligt skadade.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Behöver jag skicka med tillbehör (laddare, kabel osv.)?</div>
    <div class="text-box">
      <div class="text">
        Det är inte obligatoriskt, men rekommenderas. Att inkludera tillbehör bidrar till hållbarhet och korrekt återanvändning.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Behöver jag skicka med hörlurar?</div>
    <div class="text-box">
      <div class="text">
        Nej. Av hygieniska skäl kommer hörlurar att kasseras och inte beaktas i utvärderingen.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Behöver jag skicka inköpskvittot?</div>
    <div class="text-box">
      <div class="text">
        Nej, det krävs inte för utvärdering eller betalning. Du kan behålla det för din egen dokumentation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Hur utvärderas min gamla enhet?</div>
    <div class="text-box">
      <div class="text">
        Vi använder certifierad diagnostikprogramvara och genomför en manuell inspektion i vårt bedömningscenter för att fastställa enhetens skick. Alla bedömnings- och databehandlingsförfaranden sker i enlighet med Dataskyddsförordningen (GDPR – EU 2016/679), vilket garanterar säkerheten och konfidentialiteten för dina uppgifter.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vad händer om det skick jag angav inte motsvarar er utvärdering?</div>
    <div class="text-box">
      <div class="text">
        Om det finns skillnader mellan det skick du angett och vår utvärdering skickar vi dig ett e-postmeddelande med:<br>
        • <strong>Ett uppdaterat erbjudande</strong> baserat på den faktiska inspektionen.<br>
        • <strong>Diagnosrapporten</strong> och orsakerna till avvikelsen.<br><br>
        Du kan välja att acceptera eller avvisa erbjudandet:<br>
        • Om du accepterar, slutförs Trade-In-processen och du får betalningen till ditt bankkonto inom 3 arbetsdagar.<br>
        • Om du avvisar, beror returprocessen på din plats:<br>
        &nbsp;&nbsp;• För kunder i Spanien: retursändningen ordnas kostnadsfritt och bekostas av Danghuan Europe S.L.<br>
        &nbsp;&nbsp;• För kunder utanför Spanien: en returavgift på upp till 22 EUR / 19 GBP / 165 DKK / 245 SEK (inkl. moms) tillkommer.<br>
        &nbsp;&nbsp;• Avgiften ska betalas inom 5 kalenderdagar efter att du fått betalningsbegäran, med hjälp av den officiella förbetalda returfraktetiketten som tillhandahålls av Danghuan.<br>
        &nbsp;&nbsp;• Betalningsuppgifterna tillhandahålls på begäran eller inkluderas i e-postmeddelandet med betalningslänken.<br>
        &nbsp;&nbsp;• När betalningen (om tillämpligt) har bekräftats kommer Danghuan att verifiera transaktionen inom 5 arbetsdagar och ordna retursändningen till din ursprungliga adress. Du får ett e-postmeddelande när försändelsen har skickats, inklusive motsvarande spårningsinformation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vad händer om jag inte svarar på det uppdaterade erbjudandet?</div>
    <div class="text-box">
      <div class="text">
        Om inget svar tas emot inom 30 kalenderdagar från underrättelsen anses det reviderade erbjudandet automatiskt avvisat.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vad händer med mina personuppgifter?</div>
    <div class="text-box">
      <div class="text">
        Du måste radera all data innan du skickar din gamla enhet. Om vi upptäcker kvarvarande data kommer vi att pausa processen och kontakta dig för att ta bort dem. Vi följer fullt ut GDPR (EU-förordning 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vem betalar fraktkostnaderna?</div>
    <div class="text-box">
      <div class="text">
        Den första försändelsen är alltid kostnadsfri.<br><br>
        Om du avvisar det uppdaterade erbjudandet:<br>
        • För kunder i Spanien: retursändningen ordnas gratis och bekostas av Danghuan Europe S.L.<br>
        • För kunder utanför Spanien: en returavgift på upp till 22 EUR / 19 GBP / 165 DKK / 245 SEK (inkl. moms) tillkommer.<br>
        • Avgiften ska betalas inom 5 kalenderdagar efter att du fått betalningsbegäran, med hjälp av den officiella förbetalda returfraktetiketten som tillhandahålls av Danghuan.<br>
        • Betalningsuppgifterna tillhandahålls på begäran eller inkluderas i e-postmeddelandet med betalningslänken.<br>
        • När betalningen (om tillämpligt) har bekräftats kommer Danghuan att verifiera transaktionen inom 5 arbetsdagar och ordna retursändningen till din ursprungliga adress. Du kommer att meddelas via e-post när paketet har skickats, tillsammans med spårningsinformation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Vad händer om mitt paket försvinner under transporten?</div>
    <div class="text-box">
      <div class="text">
        Om din enhet försvinner under transporten kommer Danghuan Europe S.L. att hjälpa dig med transportörens officiella reklamationsprocess.<br><br>
        En försändelse anses förlorad om den inte har spårats, bekräftats eller mottagits av Danghuan inom 15 kalenderdagar från överlämningen till transportören.<br><br>
        • Du måste använda den auktoriserade förbetalda fraktetiketten från Danghuan; användning av andra metoder upphäver förlustskyddet.<br>
        • Reklamationer till UPS måste lämnas in inom 60 dagar från etikettens skapandedatum.<br>
        • För CORREOS (Spanien) bör reklamationer lämnas in så snart som möjligt, helst inom 15 dagar och senast inom ett år från avsändningsdatumet.<br>
        • Danghuan bistår i transportörens undersökning, som vanligtvis tar 30–60 dagar.<br><br>
        Om förlusten bekräftas i Danghuans logistiksystem och den auktoriserade etiketten har använts, kommer ersättningen inte att överstiga det slutliga bedömda Trade-In-värdet för enheten.<br><br>
        Godkända betalningar överförs direkt till det IBAN-konto som angavs vid registreringen.<br><br>
        <em>Observera: all ersättning är beroende av transportörens policy.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">När får jag betalningen?</div>
    <div class="text-box">
      <div class="text">
        När det slutliga erbjudandet har accepterats kommer betalningen att göras via banköverföring inom 3 arbetsdagar. Se till att ditt IBAN och ditt personliga ID-nummer är korrekta och motsvarar kontoinnehavarens namn.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Är det obligatoriskt att ange mitt personliga ID-nummer?</div>
    <div class="text-box">
      <div class="text">
        Ja. För att behandla betalningen måste du tillhandahålla ett giltigt personligt ID-nummer, utan mellanslag eller specialtecken, som överensstämmer med kontoinnehavaren till IBAN-kontot.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Kan jag avbryta min Trade-In-transaktion?</div>
    <div class="text-box">
      <div class="text">
        Ja, om din gamla enhet ännu inte har betalats. Kontakta oss så snart som möjligt på <a href="mailto:insta360@danghuan.eu">insta360@danghuan.eu</a>. Om du redan har skickat din enhet, kontakta oss inom 48 timmar; annars fortsätter återvinningsprocessen som vanligt.
      </div>
    </div>
  </div>
`;